import React from 'react';
import { Box } from '@sparrowengg/twigs-react';
import Navbar from 'commons/components/navbar';
import Documentation from 'features/documentation/components';

const DocumentationPage = () => {
  return (
    <Box css={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Navbar showPreviousBtn={false} />
      <Documentation />
    </Box>
  );
};

export default DocumentationPage;
